export default __webpack_public_path__ + "static/media/Storycess.dda0de6e.png";